// eslint-disable-next-line import/no-cycle
import { portalGate } from '../../foreground/portalGates/contentFrame/from/reactNativeWebview';
import type { WebviewNrEvent } from '../../foreground/types/events';
import type { NrEventPayloads } from '../../utils/nrEventPayloads';
import type { NrEvent } from '../../utils/nrEvents';

export function emitNrEvent<K extends NrEvent>(name: K, attrs: NrEventPayloads[K]): void {

  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
  portalGate.emit('nr_event', { name, attrs } as WebviewNrEvent);
}
